// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-box[data-v-790fa4be]{width:650px;height:450px;overflow-y:auto;padding:15px}.page-box .tips[data-v-790fa4be]{font-size:13px;color:#d8001b;line-height:15px}.page-box .fn[data-v-790fa4be]{display:grid;grid-template-columns:1fr 1fr 1fr;grid-auto-rows:auto}", ""]);
// Exports
module.exports = exports;
